'use client';

import dynamic from 'next/dynamic';

export const Flixmedia = dynamic(
  () =>
    import(/* webpackChunkName: 'Flixmedia' */ './Flixmedia.client').then((mod) => mod.Flixmedia),
  {
    ssr: false,
  },
);
